// import React, { useEffect, useState } from "react";
// import "../Megamenu/MegaMenu.css";
// import men_banner from './Components/Assets/Frontend_Assets/banner_mens.png'
// import women_banner from './Components/Assets/Frontend_Assets/banner_women.png'
// import kids_banner from './Components/Assets/Frontend_Assets/banner_kids.png'
// const categories = ["stitched", "unstitched", "accessories"];

// const MegaMenu = ({ mainCategory, show }) => {
//   const [data, setData] = useState({
//     stitched: [],
//     unstitched: [],
//     accessories: []
//   });

//   useEffect(() => {
//     if (!show) return;

//     const fetchData = async () => {
//       const result = {};

//       for (let cat of categories) {
//         const res = await fetch(
//           `${BASE_URL}/fabric-types?main_category=${mainCategory}&fabric_category=${cat}`
//         );
//         const json = await res.json();
//         result[cat] = json;
//       }

//       setData(result);
//     };

//     fetchData();
//   }, [mainCategory, show]);

//   return (
//     <div className={`mega-menu ${show ? "show" : ""}`}>
//       {/* Image Column */}
//       <div className="mega-col image-col">
//         <img
//           src={`/images/${mainCategory}.jpg`}
//           alt={mainCategory}
//         />
//       </div>

//       {/* Stitched */}
//       <div className="mega-col">
//         <h4>Stitched</h4>
//         {data.stitched.map((item) =>
//           item.fabric_types.map((type, i) => (
//             <p key={i}>{type}</p>
//           ))
//         )}
//       </div>

//       {/* Unstitched */}
//       <div className="mega-col">
//         <h4>Unstitched</h4>
//         {data.unstitched.map((item) =>
//           item.fabric_types.map((type, i) => (
//             <p key={i}>{type}</p>
//           ))
//         )}
//       </div>

//       {/* Accessories */}
//       <div className="mega-col">
//         <h4>Accessories</h4>
//         {data.accessories.map((item) =>
//           item.fabric_types.map((type, i) => (
//             <p key={i}>{type}</p>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;
// import React, { useEffect, useState } from "react";
// import "./MegaMenu.css";

// import men_banner from "../Assets/Frontend_Assets/banner_mens.png";
// import women_banner from "../Assets/Frontend_Assets/banner_women.png";
// import kids_banner from "../Assets/Frontend_Assets/banner_kids.png";

// const categories = ["stitched", "unstitched", "accessories"];

// const bannerMap = {
//   men: men_banner,
//   women: women_banner,
//   kids: kids_banner,
// };

// const MegaMenu = ({ mainCategory, show }) => {
//   const [data, setData] = useState({
//     stitched: [],
//     unstitched: [],
//     accessories: [],
//   });

//   useEffect(() => {
//     if (!show) return;

//     const fetchData = async () => {
//       const result = {};

//       for (let cat of categories) {
//         const res = await fetch(
//           `${BASE_URL}/fabric-types?main_category=${mainCategory}&fabric_category=${cat}`
//         );
//         result[cat] = await res.json();
//       }

//       setData(result);
//     };

//     fetchData();
//   }, [mainCategory, show]);

//   return (
//     <div className={`mega-menu ${show ? "show" : ""}`}>
//       <div className="mega-container">
//         {/* Image Column */}
//         <div className="mega-col image-col  ">
//           <img
//             src={bannerMap[mainCategory]}
//             alt={mainCategory}
//           />
//         </div>

//         {/* Stitched */}
//         <div className="mega-col">
//           <h4>Stitched</h4>
//           {data.stitched.map((item) =>
//             item.fabric_types.map((type, i) => (
//               <p key={i}>{type}</p>
//             ))
//           )}
//         </div>

//         {/* Unstitched */}
//         <div className="mega-col">
//           <h4>Unstitched</h4>
//           {data.unstitched.map((item) =>
//             item.fabric_types.map((type, i) => (
//               <p key={i}>{type}</p>
//             ))
//           )}
//         </div>

//         {/* Accessories */}
//         <div className="mega-col">
//           <h4>Accessories</h4>
//           {data.accessories.map((item) =>
//             item.fabric_types.map((type, i) => (
//               <p key={i}>{type}</p>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;
// import React, { useEffect, useState } from "react";
// import "./MegaMenu.css";

// import men_banner from "../Assets/Frontend_Assets/banner_mens.png";
// import women_banner from "../Assets/Frontend_Assets/banner_women.png";
// import kids_banner from "../Assets/Frontend_Assets/banner_kids.png";

// const categories = ["stitched", "unstitched", "accessories"];

// const bannerMap = {
//   men: men_banner,
//   women: women_banner,
//   kids: kids_banner,
// };

// const MegaMenu = ({ mainCategory, show, mobile }) => {
//   const [data, setData] = useState({});
//   const [openCat, setOpenCat] = useState(null);

//   useEffect(() => {
//     if (!show) return;

//     const fetchData = async () => {
//       const result = {};
//       for (let cat of categories) {
//         const res = await fetch(
//           `${BASE_URL}/fabric-types?main_category=${mainCategory}&fabric_category=${cat}`
//         );
//         result[cat] = await res.json();
//       }
//       setData(result);
//     };

//     fetchData();
//   }, [show, mainCategory]);

//   if (!show) return null;

//   return (
//     <div className={`mega-menu ${mobile ? "mobile" : ""}`}>
//       <div className="mega-container">
//         {!mobile && (
//           <div className="mega-col image-col">
//             <img src={bannerMap[mainCategory]} alt={mainCategory} />
//           </div>
//         )}

//         {categories.map(cat => (
//           <div className="mega-col" key={cat}>
//             <div
//               className="mega-title"
//               onClick={() => mobile && setOpenCat(openCat === cat ? null : cat)}
//             >
//               <h4>{cat}</h4>
//               {mobile && <span>{openCat === cat ? "−" : "+"}</span>}
//             </div>

//             {(openCat === cat || !mobile) &&
//               data[cat]?.map(item =>
//                 item.fabric_types.map((type, i) => (
//                   <p key={i}>{type}</p>
//                 ))
//               )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./MegaMenu.css";
import BASE_URL from '../../Config/api';
import men_banner from "../Assets/Frontend_Assets/banner_mens.png";
import women_banner from "../Assets/Frontend_Assets/banner_women.png";
import kids_banner from "../Assets/Frontend_Assets/banner_kids.png";

const categories = ["stitched",  "accessories"];

const bannerMap = {
  men: men_banner,
  women: women_banner,
  kids: kids_banner,
};

const MegaMenu = ({ mainCategory, show, mobile, onClose }) => {
  const [data, setData] = useState({});
  const [openCat, setOpenCat] = useState(null);

  useEffect(() => {
    if (!show) return;

    const fetchData = async () => {
      const result = {};
      for (let cat of categories) {
        const res = await fetch(
          `${BASE_URL}/fabric-types?main_category=${mainCategory}&fabric_category=${cat}`
        );
        result[cat] = await res.json();
      }
      setData(result);
    };

    fetchData();
  }, [show, mainCategory]);

  // if (!show) return null;

  return (
   <div className={`mega-menu ${show ? "show" : ""} ${mobile ? "mobile" : ""}`}>

      <div className="mega-container">
        {/* LEFT IMAGE */}
        {!mobile && (
          <div className="mega-col image-col">
            <img src={bannerMap[mainCategory]} alt={mainCategory} />
          </div>
        )}

        {/* FABRIC COLUMNS */}
        {categories.map((cat) => (
          <div className="mega-col" key={cat}>
            <div
              className="mega-title"
              onClick={() => mobile && setOpenCat(openCat === cat ? null : cat)}
            >
              <h4>{cat}</h4>
              {mobile && <span>{openCat === cat ? "−" : "+"}</span>}
            </div>

            {(openCat === cat || !mobile) &&
              data[cat]?.map((item) =>
                item.fabric_types.map((fabric, i) => (
                  <Link
                    key={i}
                    to={`/category/${mainCategory}/${cat}/${fabric}`}
                    className="mega-link"
                    onClick={onClose}
                  >
                    {fabric}
                  </Link>
                ))
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenu;

